export default "__VITE_ASSET__ClfIcWyi__"